module.exports = __webpack_public_path__ + "img/soulition3.08493d69.png";